//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "backbone",
  "jquery",
  "marionette",
  "messaging/messenger",
  "./departmentListView",
  "modules/accountAdmin/departmentAdmin/departmentModel",
  "modules/shared/sortableList/sortableListModule",
], function (
  Backbone,
  $,
  Marionette,
  Messenger,
  DepartmentListView,
  DepartmentModel,
  SortableListModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "departmentList";
      this.region = options.region;
      this.namespace = options.namespace;
      this.tenant = options.model;
      this._setUpVents();
    },
    show: function () {
      const headers = Messenger.reqres.request("department:list:headers");

      Messenger.onSave(function () {
        Messenger.saveAttempted(true);
      }, this);

      const extendedEvents = {
        "click .deleteDepartment": function () {
          const model = this.model;
          Messenger.yesNoDialog(
            $.t("admin.department.confirmDeleteDepartment", { name: model.get("name") }),
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Department",
                  id: model.id,
                  idType: "Department",
                  object: "Department",
                  source: "Departments List",
                });
                model.deleteModel();
              },
            },
            this,
          );
        },
      };

      this.departments = Messenger.reqres.request("tenant:departments", {
        tenantId: this.tenant.id,
      });
      this.layout = new DepartmentListView.departmentListLayout();
      this.departmentList = this.addSubModule(
        new SortableListModule({
          region: this.layout.departmentList,
          headers: headers,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          namespace: this.namespace,
          extendedEvents: extendedEvents,
        }),
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(this.departments);
        },
        this,
      );
      this.layout.on("add:department", this._onAddDepartment, this);
      this.showRegion(this.layout);
    },
    _onAddDepartment: function () {
      this.departments.onSynced(function () {
        const department = this.departments.addDepartment();
        Messenger.vent.trigger("show:tenant:profile:department", { department: department });
      }, this);
    },
    _onShowDepartments: function () {
      this.show();
      Backbone.history.navigate("accountAdmin/tenants/" + this.tenant.id + "/departments");
    },
    _showSubViews: function (departments) {
      departments.onSynced(function () {
        this.departmentList.show(departments);
      }, this);
    },
    _setUpVents: function () {
      Messenger.vent.on("show:tenant:profile:departments", this._onShowDepartments, this);
      //a row was selected in the sortable list (prepend namespace)
      Messenger.vent.on(
        this.namespace + ":selected:row",
        function (model) {
          Messenger.vent.trigger("show:tenant:profile:department", { department: model });
        },
        this,
      );
    },
  });
});
